import posthog from '../posthog';
import { FLOW_VERSION } from './flowConfig';

/**
 * PostHog events for the two-phase /try chat. Ids, slugs and counts only —
 * never free text, dates, names or anything else personal.
 */
type AlmaEvent =
  | { name: 'alma_p1_step_viewed'; props: { step_id: string } }
  | { name: 'alma_p1_step_completed'; props: { step_id: string } }
  | { name: 'alma_p1_step_back'; props: { from_step: string; to_step: string } }
  | { name: 'alma_p1_completed'; props: { duration_ms: number } }
  | { name: 'alma_p2_started'; props: Record<string, never> }
  | { name: 'alma_p2_question_answered'; props: { index: number } }
  | { name: 'alma_p2_completed'; props: { questions_asked: number; duration_ms: number } }
  | { name: 'alma_abandoned'; props: { phase: 1 | 2; last_step: string } }
  | { name: 'alma_option_list_failed'; props: { question_key: string } };

export function trackAlma<E extends AlmaEvent>(name: E['name'], props: E['props']): void {
  try {
    posthog.capture(name, { ...props, flow_version: FLOW_VERSION });
  } catch { /* analytics must never break the chat */ }
}
